import { ChevronLeft, ChevronRight } from "lucide-react";
import React from "react";
import IconButton from "../../../IconButton";
import { Select } from "../../../Input/Select";
import Typography from "../../../Typography";
import { convertStringToNum, rowsPerPageSelectOptions } from "./logic";
import { BasePagination, PaginationWrapper } from "./styled";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function Pagination(_ref) {
  var rowsPerPageOptions = _ref.rowsPerPageOptions,
    pagination = _ref.pagination,
    data = _ref.data;
  var fns = pagination.fns,
    state = pagination.state;
  var onSetSize = fns.onSetSize,
    onSetPage = fns.onSetPage;
  var page = state.page,
    size = state.size,
    getTotalPages = state.getTotalPages,
    getPageBoundaries = state.getPageBoundaries;
  var nodes = data.nodes;
  var _getPageBoundaries = getPageBoundaries(nodes),
    start = _getPageBoundaries.start,
    end = _getPageBoundaries.end;
  var totalPages = getTotalPages(nodes);
  var totalRows = nodes.length;
  var selectOptions = rowsPerPageSelectOptions(rowsPerPageOptions);
  var disableNavigateNext = totalPages === page + 1 || totalPages === 1;
  var defaultSelectValue = {
    value: size.toString(),
    label: size.toString()
  };
  return /*#__PURE__*/_jsx(BasePagination, {
    children: /*#__PURE__*/_jsxs(PaginationWrapper, {
      children: [/*#__PURE__*/_jsx(Typography, {
        color: "inherit",
        variant: "inherit",
        children: "Rows / page"
      }), /*#__PURE__*/_jsx(Select, {
        name: "rowsPerPage-select-".concat(Object.keys(nodes[0])),
        id: "rowsPerPage-select-".concat(Object.keys(nodes[0])),
        options: selectOptions,
        value: defaultSelectValue,
        onChange: function onChange(_ref2) {
          var value = _ref2.value;
          return onSetSize(convertStringToNum(value));
        },
        disabled: !totalPages || totalRows < rowsPerPageOptions[0],
        placeholder: "...",
        isSearchable: false,
        portalMenu: true
      }), /*#__PURE__*/_jsx(Typography, {
        color: "inherit",
        variant: "inherit",
        children: "".concat(start, " - ").concat(end, " of ").concat(totalRows)
      }), /*#__PURE__*/_jsx(IconButton, {
        tooltipContent: "Previous page",
        icon: /*#__PURE__*/_jsx(ChevronLeft, {}),
        disabled: page === 0,
        onClick: function onClick() {
          return onSetPage(page - 1);
        }
      }), /*#__PURE__*/_jsx(IconButton, {
        tooltipContent: "Next page",
        icon: /*#__PURE__*/_jsx(ChevronRight, {}),
        disabled: disableNavigateNext,
        onClick: function onClick() {
          return onSetPage(page + 1);
        }
      })]
    })
  });
}
Pagination.displayName = "Pagination";
export default Pagination;